import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { PrintFormatsService } from "../print-formats.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { TableConstants } from "src/app/constants/tableConstants";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { CommonService } from "src/app/core/services/common.service";
import { TranslateService } from "@ngx-translate/core";
import { ScreenConstants } from "src/app/constants/screenId.constants";

@Component({
  selector: "app-create-edit-print-formats",
  templateUrl: "./create-edit-print-formats.component.html",
  styleUrls: ["./create-edit-print-formats.component.scss"],
})
export class CreateEditPrintFormatsComponent implements OnInit {
  printFormat;
  fieldsOfprintFormat;
  numPages: number = 0;
  numElements: number = 0;
  totalElements: number = 0;
  operation: string;
  routing = RoutingConstants.printsFormatsRoutingCreateEdit;
  tableList = TableConstants.fieldsOfFormats;
  options = TableConstants.NotShowCreateDeleteAndArrowUpDownAndShowLabel;
  filtersTableJSON;
  filtersTable;

  constructor(
    private printFormatsService: PrintFormatsService,
    private toastrAlertService: ToastrAlertService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private filtersTableStateService: FiltersTableStateService,
    private commonService: CommonService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.initFormGroup();
    this.operation = this.activatedRoute.data["_value"]["operation"];
    if (
      this.operation === "edicion" &&
      this.activatedRoute.snapshot.params.id
    ) {
      let id = this.activatedRoute.snapshot.params.id;
      this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
        this.routing.id,
        ScreenConstants.admSistemas.printFormats
      );
      this.filtersTable =
        "?" + this.filtersTableStateService.getString(this.filtersTableJSON);
      this.printFormatsService.getPrintFormatById(id).subscribe(
        (data) => {
          this.setValues(data);
          this.getFieldsOfFormat();
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    }
  }

  initFormGroup() {
    this.printFormat = new FormGroup({
      fiId: new FormControl("", [
        Validators.required,
        Validators.maxLength(64),
      ]),
      fiDesc: new FormControl("", Validators.maxLength(128)),
    });
  }

  setValues(data) {
    this.printFormat.patchValue({
      fiId: data.fiId,
      fiDesc: data.fiDesc,
    });
  }

  onCreate() {
    this.printFormatsService
      .createPrintFormat(this.printFormat.value)
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(
            data["mensaje"],
            this.routing.list
          );
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  onUpdate() {
    this.printFormatsService
      .updatePrintFormat(this.printFormat.value)
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(
            data["mensaje"],
            this.routing.list
          );
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }
  onSave() {
    let invalidFields = this.commonService.findInvalidControls(
      this.printFormat.controls
    );
    if (invalidFields.length > 0) {
      let text = this.commonService.getValueOfLabelsById(invalidFields);
      this.toastrAlertService.toastrFail(text);
    } else {
      if (this.operation === "edicion") {
        this.onUpdate();
      } else if (this.operation === "creacion") {
        this.onCreate();
      }
    }
  }

  getFieldsOfFormat() {
    this.printFormatsService
      .listFieldsByPrintFormat(this.filtersTable, this.printFormat.value.fiId)
      .subscribe(
        (data) => {
          this.fieldsOfprintFormat = data["content"];
          this.numPages = data["totalPages"] == 0 ? 1 : data["totalPages"];
          this.numElements = data["numberOfElements"];
          this.totalElements = data["totalElements"];
          if (data["content"] && data["content"].length == 0) {
            let message = this.translateService.instant(
              "messages.notFoundResutls"
            );
            this.toastrAlertService.toastrWarning(message);
            this.numPages = 1;
          }
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  goList() {
    this.router.navigate([this.routing.list]);
  }

  filterTable(value) {
    this.filtersTableJSON = value.filterTableJSON;
    this.filtersTable = "?" + value.filterTableString;
    this.getFieldsOfFormat();
  }

  removeElements(value) {}
}
